<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const id = $props.id();
	const { data, lightboxId = id }: ContentBlockComponentProps<ContentType.Quotation> = $props();
</script>

<div class="grid-container full-width">
	<blockquote
		class="container-8 font-druk-cond text-cmcsecondary text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-6xl 2xl:text-[4rem] mb-6"
	>
		<q><Formatted text={data.quotation} /></q>
	</blockquote>

	<figure class="mx-auto w-fit text-center flex flex-col items-center gap-4">
		<Media
			lightbox={lightboxId}
			width={96}
			height={96}
			class="min-w-24 max-w-24 rounded-full mx-auto bg-white"
			source={data.image}
			alt={data.authorName}
			sourcesets={{
				"<2xl": [96, 0],
				">2xl": [96, 0],
			}}
		/>
		<figcaption class="font-medium text-xs/[1.5] lg:text-base flex-col items-center flex">
			<strong><Formatted text={data.authorName} /></strong>
			<span><Formatted text={data.authorTitle} /></span>
		</figcaption>
	</figure>
</div>
